/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".editingInput_207afe02{border:0px;outline:none;width:100%}.editingInput_207afe02::-ms-clear{display:none}.editingContainer_207afe02{margin:4px}\n"}]);
export const editingInput = "editingInput_207afe02";
export const editingContainer = "editingContainer_207afe02";